import { Breadcrumb } from '../../molecules/breadcrumb' //'@organice/molecules'
import React from 'react'
import { BreadcrumbItem } from '@organice/atoms'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useBreadcrumbs } from '@organice/router/useBreadcrumbs'
import { IRouteForBC } from '@organice/router/useBreadcrumbs'
import styled from '@emotion/styled'

const urlParamsRegEx = /\/:[a-z]/

// export interface BreadcrumbsProps {}
export const Breadcrumbs: React.FC = () => {
  const { routes } = useBreadcrumbs()
  const { t } = useTranslation()

  const routeTitle = (route: IRouteForBC) =>
    typeof route.title === 'string' ? <>{t(route.title)}</> : route.title

  return (
    <>
      <StyledBreadcrumb>
        {routes.map((route, i, arr) => {
          const pathContainsParams = urlParamsRegEx.test(route.path)
          return (
            <BreadcrumbItem key={route.path}>
              {arr.length - 1 === i ? (
                routeTitle(route)
              ) : (
                <>
                  {pathContainsParams ? (
                    <span>{routeTitle(route)}</span>
                  ) : (
                    <Link to={route.path}>{routeTitle(route)}</Link>
                  )}
                </>
              )}
            </BreadcrumbItem>
          )
        })}
      </StyledBreadcrumb>
    </>
  )
}

const StyledBreadcrumb = styled(Breadcrumb)`
  .ant-spin {
    max-height: 17px;
    position: relative;
    top: -3px;
  }

  ol {
    max-width: calc(90vw - 20px);
    display: flex;
    flex-wrap: nowrap;
    overflow: hidden;
    list-style: none;
    padding: 0;
    margin: 0;
  }

  ol > li {
    display: flex;
    align-items: center;
    white-space: nowrap;
  }

  ol > li:not(:first-child) {
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0; /* necessary for ellipsis to work in flex */
  }

  ol > li:not(:first-child) .ant-breadcrumb-link,
  ol > li:not(:first-child) .ant-breadcrumb-link a {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
  }

  .ant-breadcrumb-separator {
    flex-shrink: 0;
    margin: 0 4px;
  }
`
